import { useSearchContext } from '../context/SearchContext';
import { useRouter } from 'next/router';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import { InputOption } from '../../../new-lib/types/search-filters';

export const useSorting = () => {
  const router = useRouter();
  const { searchFiltersState, filterOptions } = useSearchContext();

  const sorting: InputOption[] = [];

  if (searchFiltersState.searchFilters.category === 'property') {
    sorting.push(...filterOptions[SearchFiltersTypes.SORT_BY]);
  } else {
    if (router.asPath.startsWith('/search')) {
      sorting.push(
        ...(filterOptions[SearchFiltersTypes.SORT_COMPOUND] ?? []).filter(
          item =>
            item.options?.for === 'all' ||
            item.options?.for === 'segmented_views'
        )
      );
    } else {
      sorting.push(
        ...(filterOptions[SearchFiltersTypes.SORT_COMPOUND] ?? []).filter(
          item =>
            item.options?.for === 'all' ||
            item.options?.for === 'non_segmented_views'
        )
      );
    }
  }

  return { sorting };
};
